import Image0 from '../../assets/Photos/photo_carrusel_0.jpg';
import Image1 from '../../assets/Photos/photo_carrusel_1.jpg';
import Image2 from '../../assets/Photos/photo_carrusel_2.jpg';
import Image3 from '../../assets/Photos/photo_carrusel_3.jpg';
import Image4 from '../../assets/Photos/photo_carrusel_4.jpg';
import Image5 from '../../assets/Photos/photo_carrusel_5.jpg';
import Image6 from '../../assets/Photos/photo_carrusel_6.jpg';
import Image7 from '../../assets/Photos/photo_carrusel_7.jpg';
import Image8 from '../../assets/Photos/photo_carrusel_8.jpg';
import Image9 from '../../assets/Photos/photo_carrusel_9.jpg';
import Image10 from '../../assets/Photos/photo_carrusel_10.jpg';
import Image11 from '../../assets/Photos/photo_carrusel_11.jpg';
import Image12 from '../../assets/Photos/photo_carrusel_12.jpg';
import Image13 from '../../assets/Photos/photo_carrusel_13.jpg';
import Image14 from '../../assets/Photos/photo_carrusel_14.jpg';
import Image15 from '../../assets/Photos/photo_carrusel_15.jpg';
import Image16 from '../../assets/Photos/photo_carrusel_16.jpg';
import Image17 from '../../assets/Photos/photo_carrusel_17.jpg';
import Image18 from '../../assets/Photos/photo_carrusel_18.jpg';
import Image19 from '../../assets/Photos/photo_carrusel_19.jpg';
import Image20 from '../../assets/Photos/photo_carrusel_20.jpg';
import Image21 from '../../assets/Photos/photo_carrusel_21.jpg';
import Image22 from '../../assets/Photos/photo_carrusel_22.jpg';
import { useSelector } from 'react-redux';
import st from './Photos.module.css';


const Photos = () => {

 const leng = useSelector((state)=>state.lenguage);

const images = [
    Image0,Image1,Image2,Image3,Image4,Image5,Image6,Image7,Image8,Image9,Image10,Image11,Image12,Image13,
    Image14,Image15,Image16,Image17,Image18,Image19,Image20,Image21,Image22
  ];


return (
    <div className={st.viewport}>
        <p className={st.title}> 
            {leng === true ? 'Galería de Fotos' : 'Photo Gallery'}
        </p>
        <div className={st.carousel}>
            
                <div className={st.group}>
                    {images.map((src, i) => (
                        <img key={i} src={src} alt="" className={st.card} />
                    ))}
                </div>

                <div ariah-hidden className={st.group}>
                    {images.map((src, i) => (
                        <img key={i} src={src} alt="" className={st.card} />
                    ))}
                </div>
                        
        </div>
    </div>
);
}
        




export default Photos;